module.exports = __webpack_public_path__ + "static/media/andro.7886de16.svg";